import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Sidebar } from "primereact/sidebar";
import logoSkanPay from "../images/skanpay.png";
import MenuIcon from "@mui/icons-material/Menu";
import FolderIcon from "@mui/icons-material/Folder";
import LanguageIcon from "@mui/icons-material/Language";
import "../styles/layout.css";

const MenuFrench = () => {
  return (
    <>
      <ul className="menu flex flex-col gap-y-2 w-full rounded-box">
        {/* PREREQUIS Section */}
        <li>
          <details open>
            <summary className="text-[15px] font-bold text-black">
              <FolderIcon className="text-black" sx={{ fontSize: 18 }} />
              Introduction
            </summary>
            <ul className="flex flex-col gap-y-1 ml-2">
              <li>
                <NavLink
                  to="/"
                  className="ml-2 text-[14px] active-link text-black menu-item-with-badge"
                >
                  Présentation
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/prerequis"
                  className="ml-2 text-[14px] active-link text-black menu-item-with-badge"
                >
                  Prérequis
                </NavLink>
              </li>
            </ul>
          </details>
        </li>

        {/* API DE PAIEMENT Section */}
        <li>
          <details open>
            <summary className="text-[15px] font-bold text-black">
              <FolderIcon className="text-black" sx={{ fontSize: 18 }} />
              API de paiement
            </summary>
            <ul className="flex flex-col gap-y-1 ml-2">
              <li>
                <NavLink
                  to="/paiement_direct"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  Paiement Direct
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/paiement_differe"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  Paiement Différé
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/paiement_redirige"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  Paiement Redirigé
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/paiement_status"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  Statut Paiement
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/callback_url"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  Callback URL
                </NavLink>
              </li>
            </ul>
          </details>
        </li>

        {/* API DE REVERSEMENT Section */}
        <li>
          <details open>
            <summary className="text-[15px] font-bold text-black">
              <FolderIcon className="text-black" sx={{ fontSize: 18 }} />
              API de reversement
            </summary>
            <ul className="flex flex-col gap-y-1 ml-2">
              <li>
                <NavLink
                  to="/reversement"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  Reversement client
                </NavLink>
              </li>
            </ul>
          </details>
        </li>

        <li>
          <ul className="flex flex-col gap-y-1 ml-2">
            <li>
              <NavLink
                to="/solde"
                className="text-[14px] active-link text-black menu-item-with-badge"
              >
                Solde
              </NavLink>
            </li>
          </ul>
        </li>

        <li>
          <ul className="flex flex-col gap-y-1 ml-2">
            <li>
              <a
                href="./SkanPay_API_Documentation.postman_collection.json"
                download="SkanPay_API_Documentation.postman_collection.json"
                className="text-[14px] active-link text-black menu-item-with-badge"
              >
                JSON Collections
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

const MenuEnglish = () => {
  return (
    <>
      {/* Introduction */}
      <div className="pl-2.5">
        <NavLink
          to="/"
          className="text-lg active-link-intro text-black font-semibold block px-4 py-2 menu-item-with-badge rounded-lg"
        >
          Introduction
        </NavLink>
      </div>

      <ul className="menu flex flex-col gap-y-2 w-full rounded-box">
        {/* PREREQUISITES Section */}
        <li>
          <details open>
            <summary className="text-[15px] font-bold text-black">
              <FolderIcon className="text-black" sx={{ fontSize: 18 }} />
              PREREQUISITES
            </summary>
            <ul className="flex flex-col gap-y-1 ml-2">
              <li>
                <NavLink
                  to="/prerequis"
                  className="ml-2 text-[14px] active-link text-black menu-item-with-badge"
                >
                  Account & access
                </NavLink>
              </li>
            </ul>
          </details>
        </li>

        {/* PAYMENT API Section */}
        <li>
          <details open>
            <summary className="text-[15px] font-bold text-black">
              <FolderIcon className="text-black" sx={{ fontSize: 18 }} />
              PAYMENT API
            </summary>
            <ul className="flex flex-col gap-y-1 ml-2">
              <li>
                <NavLink
                  to="/paiement_redirige"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  <span className="text-amber-500 font-bold">POST</span>
                  WAVE
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/paiement_direct"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  <span className="text-amber-500 font-bold">POST</span>
                  OM
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/paiement_differe"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  <span className="text-amber-500 font-bold">POST</span>
                  MTN
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/paiement_differe"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  <span className="text-amber-500 font-bold">POST</span>
                  MOOV
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/paiement_status"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  <span className="text-amber-500 font-bold">POST</span>
                  Payment status
                </NavLink>
              </li>
            </ul>
          </details>
        </li>

        {/* TRANSFER API Section */}
        <li>
          <details open>
            <summary className="text-[15px] font-bold text-black">
              <FolderIcon className="text-black" sx={{ fontSize: 18 }} />
              TRANSFER API
            </summary>
            <ul className="flex flex-col gap-y-1 ml-2">
              <li>
                <NavLink
                  to="/reversement"
                  className="text-[14px] active-link text-black menu-item-with-badge"
                >
                  <span className="text-amber-500 font-bold">POST</span>
                  Client transfer
                </NavLink>
              </li>
            </ul>
          </details>
        </li>
      </ul>
    </>
  );
};

const MenuContent = ({ language, toggleLanguage }) => {
  return (
    <>
      {/* Menu based on language */}
      {language === "fr" ? <MenuFrench /> : <MenuEnglish />}
    </>
  );
};

const Layout = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [language, setLanguage] = useState("fr");

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "fr" ? "en" : "fr"));
  };

  return (
    <>
      <div className="flex md:flex-row lg:flex-row flex-col min-h-[100vh] overflow-hidden">
        <div className="flex shadow-lg flex-col md:w-[30%] z-50 md:z-0 lg:z-0 lg:w-[25%] w-full border-r-[1px] max-h-[100vh] overflow-x-auto lg:overflow-y-auto">
          <div className="flex md:flex-col lg:flex-col md:justify-center lg:justify-center justify-between md:px-0 lg:px-0 px-[1rem] items-center mt-4">
            <div className="w-full px-4 flex items-center justify-between gap-3">
              <img
                src={logoSkanPay}
                className="w-36"
                alt="logo SkanPay"
              />
              {/* <button
                onClick={toggleLanguage}
                className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
              >
                <LanguageIcon sx={{ fontSize: 20 }} />
                <span className="text-sm font-medium">
                  {language === "fr" ? "FR" : "EN"}
                </span>
              </button> */}
            </div>

            {/* Desktop Menu */}
            <div className="lg:flex md:flex hidden flex-col mt-16 w-full px-2">
              {/* <MenuContent language={language} toggleLanguage={toggleLanguage} /> */}
              <MenuFrench />
            </div>

            <div className="md:hidden lg:hidden block mb-2 rounded-lg bg-black">
              <button
                className="text-white px-2 py-1"
                onClick={() => setVisible(true)}
              >
                <MenuIcon sx={{ fontSize: 32 }} />
              </button>
            </div>
          </div>
        </div>
        <div className="md:z-0 lg:z-0 overscroll-y-auto w-full">{children}</div>

        {/* Mobile Sidebar */}
        <div className="card flex justify-content-center">
          <Sidebar visible={visible} onHide={() => setVisible(false)}>
            <div className="flex flex-col w-full px-2">
              {/* <MenuContent language={language} toggleLanguage={toggleLanguage} /> */}
              <MenuFrench />
            </div>
          </Sidebar>
        </div>
      </div>
    </>
  );
};

export default Layout;
